<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <daily-box-form ref="form" v-model="form" :input-errors="inputErrors" @save="update" />
    </crud-update>
</template>

<script>

    import DailyBoxProvider from "../../../../providers/DailyBoxProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import DailyBoxForm from "../../../../forms/DailyBoxForm";
  
    import {Dayjs} from "@dracul/dayjs-frontend";

    export default {
        name: "DailyBoxUpdate",
        
        components: { DailyBoxForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'delivery.dailyBox.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    boxDate: this.item.boxDate?Dayjs(parseInt(this.item.boxDate)):null,
                    shift: this.item.shift,
                    rows: this.item.rows
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    DailyBoxProvider.updateDailyBox(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateDailyBox)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

